import React, { Component } from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

const colorCss = config.css.color;
const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const commonCss = config.css.commonDevice;

const CustomButton = withStyles({
  root: {
    whiteSpace: "normal",
    lineHeight: commonCss.containedButton.lineHeightOfContainedBtn,
    minHeight: 0,
    minWidth: 0,
    backgroundColor: colorCss.backgroundColorOfUnselectContainedButton,
    color: colorCss.colorOfUnselectContainedButton
  },
  containedPrimary: {
    backgroundColor: colorCss.backgroundColorOfHighlightContainedButton,
    color: colorCss.colorOfHighlightContainedButton
  },
  containedSecondary: {
    backgroundColor: colorCss.backgroundColorOfSelectContainedButton,
    color: colorCss.colorOfSelectContainedButton
  }
})(Button);

class ContainedCommonButtonView extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,

    design: PropTypes.oneOf(["primary", "bold", "soft"]),
    fontSize: PropTypes.number,
    forAccountPanel: PropTypes.bool,
    backgroundColor: PropTypes.string,
    padding: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool
  };

  static defaultProps = {
    design: "bold",
    fontSize:
      getDeviceType() === "mobile"
        ? mobileCss.fontSizeOfContainedBtn
        : desktopCss.fontSizeOfContainedBtn,
    forAccountPanel: false,
    backgroundColor: null,
    padding: "11px 36px",
    disabled: false,
    fullWidth: false
  };

  getStyle() {
    const { fontSize, forAccountPanel, backgroundColor, padding } = this.props;
    const style = { fontSize, padding };
    if (forAccountPanel) {
      style.fontSize =
        getDeviceType() === "mobile"
          ? mobileCss.fontSizeOfAccountPanelBtn
          : desktopCss.fontSizeOfAccountPanelBtn;
    }
    if (backgroundColor) style.backgroundColor = backgroundColor;
    return style;
  }

  render() {
    const { design, disabled, onClick, fullWidth, children } = this.props;
    const style = this.getStyle();

    return (
      <CustomButton
        disableRipple
        variant="contained"
        color={
          design === "primary"
            ? "primary"
            : design === "bold"
            ? "secondary"
            : "default"
        }
        style={style}
        disabled={disabled}
        fullWidth={fullWidth}
        onClick={onClick}
      >
        {children}
      </CustomButton>
    );
  }
}

export default ContainedCommonButtonView;
